<template>
  <el-dialog
      :visible.sync="visible"
      :show-close="true"
      custom-class="chart-dialog"
      width="1006px"
      @close="handleClose"
  >
    <div class="chart-content">
      <!-- 左侧聊天iframe -->
      <div class="chart-left" style="  width: 706px;">
        <iframe
            :src="chatUrl"
            frameborder="0"
            class="chat-frame"
        ></iframe>
      </div>

      <!-- 右侧内容 -->
      <div class="chart-right" style="width: 300px;">
        <div class="company-info">
          <div class="logo">
            <img :src="require('@/assets/images/logo-active.png')" :alt="getText('goodChart.logoAlt', '亚科Logo')">
          </div>
          <h3 class="company-name norem">{{ getText('goodChart.companyName', '亚科股份') }}</h3>
        </div>

        <div class="contact-info norem" :class="[currentLanguage === 'en'?'info-item_en':'']">
          <div class="info-item norem" :class="[currentLanguage === 'en'?'info-item_en':'']">
            <label>{{ getText('goodChart.productService', '产品咨询与售后服务：') }}</label>
            <div class="info-item_li">
              <span>13451648594</span>
              <span>15062454963</span>
            </div>

          </div>
          <div class="info-item norem" :class="[currentLanguage === 'en'?'info-item_en':'']">
            <label>{{ getText('goodChart.contactEmail', '联系邮箱：') }}</label>
            <div class="email-list">
              <p>mkt@yacoo.com.cn</p>
            </div>
          </div>
        </div>
        <div class="chart-btn norem">
          <el-button
              type="primary"
              @click="handleButtonClick"
          >
            {{ getText('goodChart.leaveMessage', '留言') }}
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'GoodChart',

  props: {
    type: {
      type: String,
      default: 'chat', // 可选值：chat, service, product
      validator: value => ['chat', 'service', 'product', 'customization'].includes(value)
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  watch: {
    // 监听 i18n 语言变化
    '$i18n.locale': function() {
      console.log('i18n locale changed to:', this.$i18n.locale)
      // 强制重新渲染组件以更新文本
      this.$forceUpdate()
    },
    // 监听语言变化
    currentLanguage: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // 强制重新渲染组件以更新文本
          this.$forceUpdate()
        }
      },
      immediate: false
    },
    item: {
      handler(newVal) {
        this.formData.belongs = newVal.belongs
        if(this.formData.belongs === 2){
          this.chatUrl = 'https://chatbot.weixin.qq.com/webapp/4dI4YGKLKglJxe9oEPnFyIrseJkvO6?isFloat=false&robotName=%E4%BA%9A%E7%A7%91%E5%AE%98%E7%BD%91-%E6%98%9F%E7%A7%91%E5%85%83%E5%AE%A2%E6%9C%8D'
        }else{
          this.chatUrl = 'https://chatbot.weixin.qq.com/webapp/CJMBNZFGwytui4VHJTvYfMeMAE5Frb?isFloat=false&robotName=%E4%BA%9A%E7%A7%91%E5%AE%98%E7%BD%91-%E4%BA%9A%E7%A7%91%E5%AE%A2%E6%9C%8D'
        }
      },
      immediate: true
    }
  },

  data() {
    return {
      formData: {
        belongs: 1
       },
      visible: false,
      chatUrl: 'https://chatbot.weixin.qq.com/webapp/CJMBNZFGwytui4VHJTvYfMeMAE5Frb?isFloat=false&robotName=%E4%BA%9A%E7%A7%91%E5%AE%98%E7%BD%91-%E4%BA%9A%E7%A7%91%E5%AE%A2%E6%9C%8D'
    }
  },

  computed: {
    ...mapState({
      currentLanguage: state => state?.app?.language || 'zh'
    }),
  },

  methods: {
    // 安全的文本获取方法
    getText(key, fallback) {
      try {
        // 尝试使用 i18n
        if (this.$i18n && this.$i18n.t) {
          return this.$i18n.t(key)
        }
        // 如果 i18n 不可用，返回默认值
        return fallback
      } catch (error) {
        console.warn(`Translation failed for key: ${key}`, error)
        return fallback
      }
    },

    show() {
      this.visible = true
    },

    handleClose() {
      this.visible = false
    },

    handleButtonClick() {
      // 根据type调用不同的弹窗
      switch(this.type) {
        case 'service':
          this.$service(this.item)
          break
        case 'product':
          this.$product(this.item)
          break
        case 'customization':
          this.$croOrCdmo(this.item)
          break
        default:
          // 默认行为，可以是什么都不做
          console.log('默认聊天模式')
      }
    }
  },

  beforeDestroy() {
    // 确保组件销毁时清理资源
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>

<style scoped>

.webapp-contain,
.webapp_window {
  width: 100% !important;
  height: 100% !important;
  min-width: 0 !important;
  min-height: 0 !important;
  box-sizing: border-box;
  overflow: hidden;
}
</style>

<style lang="less" scoped>
@import '../assets/styles/variables.less';
@import '../assets/styles/mixins.less';
::v-deep .el-dialog{
}
::v-deep .el-dialog__body {
  padding: 0;
}
::v-deep .el-dialog__header {
  padding: 0;
}

::v-deep .tip-brand{
  display: none !important;
}

.chart-dialog {
  :deep(.el-dialog__headerbtn) {
    z-index: 10;
    .el-dialog__close {
      color: #999;
      font-size: @font-size-note;
    }
  }
}

.chart-content {
  display: flex;
  width: fit-content;
  .chart-left {
    min-width: 706px;
    min-height: 800px;
    //缩小到90%
    transform: scale(0.9);
    border-right: 1px solid #eee;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .chat-frame {
      width: 100%;
      height: 100%;
      transform: scale(1.12);
      min-width: 706px;
      min-height: 800px;
      display: block;
      border: none;
    }
  }

  .chart-right {
    padding: 30px 10px;
    background-color: #fff;
    display: flex;
    flex-direction: column;

    .company-info {
      text-align: center;
      margin-bottom: 40px;
      padding-top: 40px;
      .logo {
        border-radius: 50%;
        background: #F1F5F8;
        margin: 0 auto 30px;
        width: 120px;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 80px;
          height: auto;
        }
      }

      .company-name {
        font-size: 24px;
        color: #333;
        margin: 0;

      }
    }

    .contact-info {
      height: fit-content;
      .info-item {
        margin-bottom: 20px;
        display: flex;
        label {
          flex-shrink: 0;
          color: #666;
          font-size: 16px;
          margin-bottom: 5px;
          display: block;
        }

        span {
          color: #333;
          font-size: 16px;
        }

        .info-item_li {
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          gap: 5px;
        }

        .email-list {
          p {
            margin: 0 0 5px;
            color: #333;
            font-size: 16px;
          }
        }
      }
      .info-item_en {
        display: block !important;
      }
    }

    .qr-code {
      text-align: center;

      img {
        width: 120px;
        height: 120px;
        margin-bottom: 10px;
      }

      p {
        font-size: 14px;
        color: #666;
        margin: 0;
      }
    }

    .chart-btn {
      text-align: center;
      margin-top: 20px;

      :deep(.el-button) {
        width: fit-content;
        min-width: 100px;
        height: 30px;
        background: #325177;
        border-color: #325177;
        border-radius: 5px;
        font-size: 14px;
        padding: 0 12px;
        &:hover {
          background: lighten(#325177, 10%);
          border-color: lighten(#325177, 10%);
        }
      }
    }
  }
}
</style> 